export interface ItbisTypeOption {
    code: string;
    name?: string;
    rate: number | string;
    is_active?: boolean;
}

/**
 * Calculate ITBIS amount for a given taxable base and catalog rate.
 * Pure function — no side effects, deterministic.
 * Rounds to 2 decimal places using Math.round(base * rate * 100) / 100.
 */
export function calculateItbis(rate: number, baseAmount: number): number {
    if (!rate || rate <= 0 || !baseAmount) {
        return 0;
    }
    return Math.round(baseAmount * rate * 100) / 100;
}

export function rateForItbisType(itbisType: string, types: ItbisTypeOption[]): number {
    const match = types.find((t) => t.code === itbisType && t.is_active !== false);
    return match ? Number(match.rate) : 0;
}

export function defaultItbisTypeCode(types: ItbisTypeOption[]): string {
    const active = types.filter((t) => t.is_active !== false);
    return active.find((t) => t.code.startsWith('gravado_'))?.code ?? active[0]?.code ?? '';
}
